import { jsx as t } from "react/jsx-runtime";
import { makeStyles as i } from "tss-react/mui";
import m from "./ResponsiveDialog.style.js";
import p from "../MobileDialog/MobileDialog.js";
import c from "../DesktopDialog/DesktopDialog.js";
const f = i()(m), g = ({
  children: o,
  isMobile: a,
  open: s,
  onClose: e,
  dataTestid: r
}) => {
  const { classes: l } = f();
  return a ? /* @__PURE__ */ t(
    p,
    {
      open: s,
      onClose: e,
      dataTestid: r,
      dialogClass: {
        paper: l.paperFullScreen
      },
      children: o
    }
  ) : /* @__PURE__ */ t(
    c,
    {
      open: s,
      onClose: e,
      dataTestid: r,
      className: l.dialog,
      children: o
    }
  );
}, k = g;
export {
  k as default
};
